<template>
<div class="chapter">
<div class="inner_page">
<h1>Table des Matières</h1>
<p><span href="#/c001" title="Link target outside of Sample">Page de Titre</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Droits d'Auteur</span></p>
<p><a href="#/c003">Houx et Amour | Auteure à Succès USA Today | Amanda Mariel</a></p>
<p><a href="#/c004">Chapitre 1</a></p>
<p><span href="#/c005" title="Link target outside of Sample">Chapitre 2</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Chapitre 3</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Chapitre 4</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Chapitre 5</span></p>
<p><span href="#/c009" title="Link target outside of Sample">A propos de l’auteur</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Le mot de la fin</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1672c4ca